const urlAssets = 'https://warren.com.br/assets/nebraska';
const assetPathBanks = 'bank';
const assetPathCryptos = 'crypto';
const assetPathStocks = 'stock';
const MapAssetCode = new Map([
    ['000', `${urlAssets}/${assetPathBanks}/000.svg`],
    ['001', `${urlAssets}/${assetPathBanks}/001.svg`],
    ['003', `${urlAssets}/${assetPathBanks}/003.svg`],
    ['004', `${urlAssets}/${assetPathBanks}/004.svg`],
    ['007', `${urlAssets}/${assetPathBanks}/007.svg`],
    ['011', `${urlAssets}/${assetPathBanks}/011.svg`],
    ['021', `${urlAssets}/${assetPathBanks}/021.svg`],
    ['025', `${urlAssets}/${assetPathBanks}/025.svg`],
    ['033', `${urlAssets}/${assetPathBanks}/033.svg`],
    ['037', `${urlAssets}/${assetPathBanks}/037.svg`],
    ['041', `${urlAssets}/${assetPathBanks}/041.svg`],
    ['047', `${urlAssets}/${assetPathBanks}/047.svg`],
    ['064', `${urlAssets}/${assetPathBanks}/064.svg`],
    ['070', `${urlAssets}/${assetPathBanks}/070.svg`],
    ['077', `${urlAssets}/${assetPathBanks}/077.svg`],
    ['082', `${urlAssets}/${assetPathBanks}/082.svg`],
    ['104', `${urlAssets}/${assetPathBanks}/104.svg`],
    ['119', `${urlAssets}/${assetPathBanks}/119.svg`],
    ['121', `${urlAssets}/${assetPathBanks}/121.svg`],
    ['140', `${urlAssets}/${assetPathBanks}/140.svg`],
    ['197', `${urlAssets}/${assetPathBanks}/197.svg`],
    ['208', `${urlAssets}/${assetPathBanks}/208.svg`],
    ['212', `${urlAssets}/${assetPathBanks}/212.svg`],
    ['218', `${urlAssets}/${assetPathBanks}/218.svg`],
    ['237', `${urlAssets}/${assetPathBanks}/237.svg`],
    ['246', `${urlAssets}/${assetPathBanks}/246.svg`],
    ['260', `${urlAssets}/${assetPathBanks}/260.svg`],
    ['269', `${urlAssets}/${assetPathBanks}/269.svg`],
    ['318', `${urlAssets}/${assetPathBanks}/318.svg`],
    ['323', `${urlAssets}/${assetPathBanks}/323.svg`],
    ['335', `${urlAssets}/${assetPathBanks}/335.svg`],
    ['336', `${urlAssets}/${assetPathBanks}/336.svg`],
    ['340', `${urlAssets}/${assetPathBanks}/340.svg`],
    ['341', `${urlAssets}/${assetPathBanks}/341.svg`],
    ['362', `${urlAssets}/${assetPathBanks}/362.svg`],
    ['368', `${urlAssets}/${assetPathBanks}/368.svg`],
    ['371', `${urlAssets}/${assetPathBanks}/371.svg`],
    ['380', `${urlAssets}/${assetPathBanks}/380.svg`],
    ['389', `${urlAssets}/${assetPathBanks}/389.svg`],
    ['413', `${urlAssets}/${assetPathBanks}/413.svg`],
    ['422', `${urlAssets}/${assetPathBanks}/422.svg`],
    ['604', `${urlAssets}/${assetPathBanks}/604.svg`],
    ['623', `${urlAssets}/${assetPathBanks}/623.svg`],
    ['637', `${urlAssets}/${assetPathBanks}/637.svg`],
    ['707', `${urlAssets}/${assetPathBanks}/707.svg`],
    ['712', `${urlAssets}/${assetPathBanks}/712.svg`],
    ['735', `${urlAssets}/${assetPathBanks}/735.svg`],
    ['743', `${urlAssets}/${assetPathBanks}/743.svg`],
    ['745', `${urlAssets}/${assetPathBanks}/745.svg`],
    ['748', `${urlAssets}/${assetPathBanks}/748.svg`],
    ['755', `${urlAssets}/${assetPathBanks}/755.svg`],
    ['756', `${urlAssets}/${assetPathBanks}/756.svg`],
    ['ADA', `${urlAssets}/${assetPathCryptos}/ADA.svg`],
    ['ATOM', `${urlAssets}/${assetPathCryptos}/ATOM.svg`],
    ['AVAX', `${urlAssets}/${assetPathCryptos}/AVAX.svg`],
    ['BNB', `${urlAssets}/${assetPathCryptos}/BNB.svg`],
    ['BTC', `${urlAssets}/${assetPathCryptos}/BTC.svg`],
    ['BUSD', `${urlAssets}/${assetPathCryptos}/BUSD.svg`],
    ['COMP', `${urlAssets}/${assetPathCryptos}/COMP.svg`],
    ['CRO', `${urlAssets}/${assetPathCryptos}/CRO.svg`],
    ['DAI', `${urlAssets}/${assetPathCryptos}/DAI.svg`],
    ['DOGE', `${urlAssets}/${assetPathCryptos}/DOGE.svg`],
    ['DOT', `${urlAssets}/${assetPathCryptos}/DOT.svg`],
    ['ETH', `${urlAssets}/${assetPathCryptos}/ETH.svg`],
    ['LINK', `${urlAssets}/${assetPathCryptos}/LINK.svg`],
    ['LTC', `${urlAssets}/${assetPathCryptos}/LTC.svg`],
    ['LUNA', `${urlAssets}/${assetPathCryptos}/LUNA.svg`],
    ['MATIC', `${urlAssets}/${assetPathCryptos}/MATIC.svg`],
    ['NEAR', `${urlAssets}/${assetPathCryptos}/NEAR.svg`],
    ['SHIB', `${urlAssets}/${assetPathCryptos}/SHIB.svg`],
    ['SOL', `${urlAssets}/${assetPathCryptos}/SOL.svg`],
    ['TRON', `${urlAssets}/${assetPathCryptos}/TRON.svg`],
    ['UNI', `${urlAssets}/${assetPathCryptos}/UNI.svg`],
    ['USDC', `${urlAssets}/${assetPathCryptos}/USDC.svg`],
    ['USDT', `${urlAssets}/${assetPathCryptos}/USDT.svg`],
    ['XRP', `${urlAssets}/${assetPathCryptos}/XRP.svg`],
    ['AALR', `${urlAssets}/${assetPathStocks}/AALR@3x.png`],
    ['ABCB', `${urlAssets}/${assetPathStocks}/ABCB@3x.png`],
    ['ABEV', `${urlAssets}/${assetPathStocks}/ABEV@3x.png`],
    ['ACNB', `${urlAssets}/${assetPathStocks}/ACNB@3x.png`],
    ['ADHM', `${urlAssets}/${assetPathStocks}/ADHM@3x.png`],
    ['AERI', `${urlAssets}/${assetPathStocks}/AERI@3x.png`],
    ['AESB', `${urlAssets}/${assetPathStocks}/AESB@3x.png`],
    ['AFLT', `${urlAssets}/${assetPathStocks}/AFLT@3x.png`],
    ['AGBK', `${urlAssets}/${assetPathStocks}/AGBK@3x.png`],
    ['AGRO', `${urlAssets}/${assetPathStocks}/AGRO@3x.png`],
    ['AGXY', `${urlAssets}/${assetPathStocks}/AGXY@3x.png`],
    ['AHEB', `${urlAssets}/${assetPathStocks}/AHEB@3x.png`],
    ['ALLD', `${urlAssets}/${assetPathStocks}/ALLD@3x.png`],
    ['ALPA', `${urlAssets}/${assetPathStocks}/ALPA@3x.png`],
    ['ALPK', `${urlAssets}/${assetPathStocks}/ALPK@3x.png`],
    ['ALSO', `${urlAssets}/${assetPathStocks}/ALSO@3x.png`],
    ['ALUP', `${urlAssets}/${assetPathStocks}/ALUP@3x.png`],
    ['AMAR', `${urlAssets}/${assetPathStocks}/AMAR@3x.png`],
    ['AMBP', `${urlAssets}/${assetPathStocks}/AMBP@3x.png`],
    ['AMER', `${urlAssets}/${assetPathStocks}/AMER@3x.png`],
    ['AMZN', `${urlAssets}/${assetPathStocks}/AMZN@3x.png`],
    ['ANIM', `${urlAssets}/${assetPathStocks}/ANIM@3x.png`],
    ['APER', `${urlAssets}/${assetPathStocks}/APER@3x.png`],
    ['APPL', `${urlAssets}/${assetPathStocks}/APPL@3x.png`],
    ['APTI', `${urlAssets}/${assetPathStocks}/APTI@3x.png`],
    ['ARML', `${urlAssets}/${assetPathStocks}/ARML@3x.png`],
    ['ARZZ', `${urlAssets}/${assetPathStocks}/ARZZ@3x.png`],
    ['ASAI', `${urlAssets}/${assetPathStocks}/ASAI@3x.png`],
    ['ATMP', `${urlAssets}/${assetPathStocks}/ATMP@3x.png`],
    ['ATOM', `${urlAssets}/${assetPathStocks}/ATOM@3x.png`],
    ['AURA', `${urlAssets}/${assetPathStocks}/AURA@3x.png`],
    ['AVLL', `${urlAssets}/${assetPathStocks}/AVLL@3x.png`],
    ['AZEV', `${urlAssets}/${assetPathStocks}/AZEV@3x.png`],
    ['AZUL', `${urlAssets}/${assetPathStocks}/AZUL@3x.png`],
    ['B3SA', `${urlAssets}/${assetPathStocks}/B3SA@3x.png`],
    ['BAHI', `${urlAssets}/${assetPathStocks}/BAHI@3x.png`],
    ['BALM', `${urlAssets}/${assetPathStocks}/BALM@3x.png`],
    ['BAUH', `${urlAssets}/${assetPathStocks}/BAUH@3x.png`],
    ['BAZA', `${urlAssets}/${assetPathStocks}/BAZA@3x.png`],
    ['BBAS', `${urlAssets}/${assetPathStocks}/BBAS@3x.png`],
    ['BBDC', `${urlAssets}/${assetPathStocks}/BBDC@3x.png`],
    ['BBML', `${urlAssets}/${assetPathStocks}/BBML@3x.png`],
    ['BBRK', `${urlAssets}/${assetPathStocks}/BBRK@3x.png`],
    ['BBSE', `${urlAssets}/${assetPathStocks}/BBSE@3x.png`],
    ['BDLL', `${urlAssets}/${assetPathStocks}/BDLL@3x.png`],
    ['BEEF', `${urlAssets}/${assetPathStocks}/BEEF@3x.png`],
    ['BEES', `${urlAssets}/${assetPathStocks}/BEES@3x.png`],
    ['BGIP', `${urlAssets}/${assetPathStocks}/BGIP@3x.png`],
    ['BIDI', `${urlAssets}/${assetPathStocks}/BIDI@3x.png`],
    ['BIOM', `${urlAssets}/${assetPathStocks}/BIOM@3x.png`],
    ['BKBR', `${urlAssets}/${assetPathStocks}/BKBR@3x.png`],
    ['BLAU', `${urlAssets}/${assetPathStocks}/BLAU@3x.png`],
    ['BMEB', `${urlAssets}/${assetPathStocks}/BMEB@3x.png`],
    ['BMGB', `${urlAssets}/${assetPathStocks}/BMGB@3x.png`],
    ['BMIN', `${urlAssets}/${assetPathStocks}/BMIN@3x.png`],
    ['BMKS', `${urlAssets}/${assetPathStocks}/BMKS@3x.png`],
    ['BMOB', `${urlAssets}/${assetPathStocks}/BMOB@3x.png`],
    ['BNBR', `${urlAssets}/${assetPathStocks}/BNBR@3x.png`],
    ['BOAS', `${urlAssets}/${assetPathStocks}/BOAS@3x.png`],
    ['BOBR', `${urlAssets}/${assetPathStocks}/BOBR@3x.png`],
    ['BPAC', `${urlAssets}/${assetPathStocks}/BPAC@3x.png`],
    ['BPAN', `${urlAssets}/${assetPathStocks}/BPAN@3x.png`],
    ['BPAR', `${urlAssets}/${assetPathStocks}/BPAR@3x.png`],
    ['BRAP', `${urlAssets}/${assetPathStocks}/BRAP@3x.png`],
    ['BRBI', `${urlAssets}/${assetPathStocks}/BRBI@3x.png`],
    ['BRDT', `${urlAssets}/${assetPathStocks}/BRDT@3x.png`],
    ['BRFS', `${urlAssets}/${assetPathStocks}/BRFS@3x.png`],
    ['BRGE', `${urlAssets}/${assetPathStocks}/BRGE@3x.png`],
    ['BRIT', `${urlAssets}/${assetPathStocks}/BRIT@3x.png`],
    ['BRIV', `${urlAssets}/${assetPathStocks}/BRIV@3x.png`],
    ['BRKM', `${urlAssets}/${assetPathStocks}/BRKM@3x.png`],
    ['BRML', `${urlAssets}/${assetPathStocks}/BRML@3x.png`],
    ['BRPR', `${urlAssets}/${assetPathStocks}/BRPR@3x.png`],
    ['BRQB', `${urlAssets}/${assetPathStocks}/BRQB@3x.png`],
    ['BRSR', `${urlAssets}/${assetPathStocks}/BRSR@3x.png`],
    ['BSEV', `${urlAssets}/${assetPathStocks}/BSEV@3x.png`],
    ['BSLI', `${urlAssets}/${assetPathStocks}/BSLI@3x.png`],
    ['BTOW', `${urlAssets}/${assetPathStocks}/BTOW@3x.png`],
    ['BTTL', `${urlAssets}/${assetPathStocks}/BTTL@3x.png`],
    ['CALI', `${urlAssets}/${assetPathStocks}/CALI@3x.png`],
    ['CAMB', `${urlAssets}/${assetPathStocks}/CAMB@3x.png`],
    ['CAML', `${urlAssets}/${assetPathStocks}/CAML@3x.png`],
    ['CARD', `${urlAssets}/${assetPathStocks}/CARD@3x.png`],
    ['CASH', `${urlAssets}/${assetPathStocks}/CASH@3x.png`],
    ['CASN', `${urlAssets}/${assetPathStocks}/CASN@3x.png`],
    ['CATA', `${urlAssets}/${assetPathStocks}/CATA@3x.png`],
    ['CBAV', `${urlAssets}/${assetPathStocks}/CBAV@3x.png`],
    ['CBEE', `${urlAssets}/${assetPathStocks}/CBEE@3x.png`],
    ['CCPR', `${urlAssets}/${assetPathStocks}/CCPR@3x.png`],
    ['CCRO', `${urlAssets}/${assetPathStocks}/CCRO@3x.png`],
    ['CEAB', `${urlAssets}/${assetPathStocks}/CEAB@3x.png`],
    ['CEBR', `${urlAssets}/${assetPathStocks}/CEBR@3x.png`],
    ['CEDO', `${urlAssets}/${assetPathStocks}/CEDO@3x.png`],
    ['CEEB', `${urlAssets}/${assetPathStocks}/CEEB@3x.png`],
    ['CEED', `${urlAssets}/${assetPathStocks}/CEED@3x.png`],
    ['CEGR', `${urlAssets}/${assetPathStocks}/CEGR@3x.png`],
    ['CEPE', `${urlAssets}/${assetPathStocks}/CEPE@3x.png`],
    ['CESP', `${urlAssets}/${assetPathStocks}/CESP@3x.png`],
    ['CGAS', `${urlAssets}/${assetPathStocks}/CGAS@3x.png`],
    ['CGRA', `${urlAssets}/${assetPathStocks}/CGRA@3x.png`],
    ['CIEL', `${urlAssets}/${assetPathStocks}/CIEL@3x.png`],
    ['CLSA', `${urlAssets}/${assetPathStocks}/CLSA@3x.png`],
    ['CLSC', `${urlAssets}/${assetPathStocks}/CLSC@3x.png`],
    ['CMIG', `${urlAssets}/${assetPathStocks}/CMIG@3x.png`],
    ['CMIN', `${urlAssets}/${assetPathStocks}/CMIN@3x.png`],
    ['CMSA', `${urlAssets}/${assetPathStocks}/CMSA@3x.png`],
    ['CNSY', `${urlAssets}/${assetPathStocks}/CNSY@3x.png`],
    ['COCE', `${urlAssets}/${assetPathStocks}/COCE@3x.png`],
    ['COGN', `${urlAssets}/${assetPathStocks}/COGN@3x.png`],
    ['CORR', `${urlAssets}/${assetPathStocks}/CORR@3x.png`],
    ['CPFE', `${urlAssets}/${assetPathStocks}/CPFE@3x.png`],
    ['CPLE', `${urlAssets}/${assetPathStocks}/CPLE@3x.png`],
    ['CRDE', `${urlAssets}/${assetPathStocks}/CRDE@3x.png`],
    ['CRFB', `${urlAssets}/${assetPathStocks}/CRFB@3x.png`],
    ['CRIV', `${urlAssets}/${assetPathStocks}/CRIV@3x.png`],
    ['CRPG', `${urlAssets}/${assetPathStocks}/CRPG@3x.png`],
    ['CSAB', `${urlAssets}/${assetPathStocks}/CSAB@3x.png`],
    ['CSAN', `${urlAssets}/${assetPathStocks}/CSAN@3x.png`],
    ['CSED', `${urlAssets}/${assetPathStocks}/CSED@3x.png`],
    ['CSMG', `${urlAssets}/${assetPathStocks}/CSMG@3x.png`],
    ['CSNA', `${urlAssets}/${assetPathStocks}/CSNA@3x.png`],
    ['CSRN', `${urlAssets}/${assetPathStocks}/CSRN@3x.png`],
    ['CTKA', `${urlAssets}/${assetPathStocks}/CTKA@3x.png`],
    ['CTNM', `${urlAssets}/${assetPathStocks}/CTNM@3x.png`],
    ['CTSA', `${urlAssets}/${assetPathStocks}/CTSA@3x.png`],
    ['CURY', `${urlAssets}/${assetPathStocks}/CURY@3x.png`],
    ['CVCB', `${urlAssets}/${assetPathStocks}/CVCB@3x.png`],
    ['CXSE', `${urlAssets}/${assetPathStocks}/CXSE@3x.png`],
    ['CYRE', `${urlAssets}/${assetPathStocks}/CYRE@3x.png`],
    ['DASA', `${urlAssets}/${assetPathStocks}/DASA@3x.png`],
    ['DESK', `${urlAssets}/${assetPathStocks}/DESK@3x.png`],
    ['DEXP', `${urlAssets}/${assetPathStocks}/DEXP@3x.png`],
    ['DIRR', `${urlAssets}/${assetPathStocks}/DIRR@3x.png`],
    ['DMMO', `${urlAssets}/${assetPathStocks}/DMMO@3x.png`],
    ['DMVF', `${urlAssets}/${assetPathStocks}/DMVF@3x.png`],
    ['DOHL', `${urlAssets}/${assetPathStocks}/DOHL@3x.png`],
    ['DOTZ', `${urlAssets}/${assetPathStocks}/DOTZ@3x.png`],
    ['DTCY', `${urlAssets}/${assetPathStocks}/DTCY@3x.png`],
    ['DTEN', `${urlAssets}/${assetPathStocks}/DTEN@3x.png`],
    ['DTEX', `${urlAssets}/${assetPathStocks}/DTEX@3x.png`],
    ['DXCO', `${urlAssets}/${assetPathStocks}/DXCO@3x.png`],
    ['EALT', `${urlAssets}/${assetPathStocks}/EALT@3x.png`],
    ['ECOR', `${urlAssets}/${assetPathStocks}/ECOR@3x.png`],
    ['ECPR', `${urlAssets}/${assetPathStocks}/ECPR@3x.png`],
    ['EEEL', `${urlAssets}/${assetPathStocks}/EEEL@3x.png`],
    ['EGIE', `${urlAssets}/${assetPathStocks}/EGIE@3x.png`],
    ['EKTR', `${urlAssets}/${assetPathStocks}/EKTR@3x.png`],
    ['ELET', `${urlAssets}/${assetPathStocks}/ELET@3x.png`],
    ['ELMD', `${urlAssets}/${assetPathStocks}/ELMD@3x.png`],
    ['EMAE', `${urlAssets}/${assetPathStocks}/EMAE@3x.png`],
    ['EMBR', `${urlAssets}/${assetPathStocks}/EMBR@3x.png`],
    ['ENAT', `${urlAssets}/${assetPathStocks}/ENAT@3x.png`],
    ['ENBR', `${urlAssets}/${assetPathStocks}/ENBR@3x.png`],
    ['ENEV', `${urlAssets}/${assetPathStocks}/ENEV@3x.png`],
    ['ENGI', `${urlAssets}/${assetPathStocks}/ENGI@3x.png`],
    ['ENJU', `${urlAssets}/${assetPathStocks}/ENJU@3x.png`],
    ['ENMT', `${urlAssets}/${assetPathStocks}/ENMT@3x.png`],
    ['EPAR', `${urlAssets}/${assetPathStocks}/EPAR@3x.png`],
    ['EQMA', `${urlAssets}/${assetPathStocks}/EQMA@3x.png`],
    ['EQPA', `${urlAssets}/${assetPathStocks}/EQPA@3x.png`],
    ['EQTL', `${urlAssets}/${assetPathStocks}/EQTL@3x.png`],
    ['ESPA', `${urlAssets}/${assetPathStocks}/ESPA@3x.png`],
    ['ESTR', `${urlAssets}/${assetPathStocks}/ESTR@3x.png`],
    ['ETER', `${urlAssets}/${assetPathStocks}/ETER@3x.png`],
    ['EUCA', `${urlAssets}/${assetPathStocks}/EUCA@3x.png`],
    ['EVEN', `${urlAssets}/${assetPathStocks}/EVEN@3x.png`],
    ['EZTC', `${urlAssets}/${assetPathStocks}/EZTC@3x.png`],
    ['FBOK', `${urlAssets}/${assetPathStocks}/FBOK@3x.png`],
    ['FESA', `${urlAssets}/${assetPathStocks}/FESA@3x.png`],
    ['FHER', `${urlAssets}/${assetPathStocks}/FHER@3x.png`],
    ['FIGE', `${urlAssets}/${assetPathStocks}/FIGE@3x.png`],
    ['FIQE', `${urlAssets}/${assetPathStocks}/FIQE@3x.png`],
    ['FLEX', `${urlAssets}/${assetPathStocks}/FLEX@3x.png`],
    ['FLRY', `${urlAssets}/${assetPathStocks}/FLRY@3x.png`],
    ['FNCN', `${urlAssets}/${assetPathStocks}/FNCN@3x.png`],
    ['FRAS', `${urlAssets}/${assetPathStocks}/FRAS@3x.png`],
    ['FRIO', `${urlAssets}/${assetPathStocks}/FRIO@3x.png`],
    ['FRTA', `${urlAssets}/${assetPathStocks}/FRTA@3x.png`],
    ['GEPA', `${urlAssets}/${assetPathStocks}/GEPA@3x.png`],
    ['GFSA', `${urlAssets}/${assetPathStocks}/GFSA@3x.png`],
    ['GGBR', `${urlAssets}/${assetPathStocks}/GGBR@3x.png`],
    ['GGPS', `${urlAssets}/${assetPathStocks}/GGPS@3x.png`],
    ['GMAT', `${urlAssets}/${assetPathStocks}/GMAT@3x.png`],
    ['GNDI', `${urlAssets}/${assetPathStocks}/GNDI@3x.png`],
    ['GOAU', `${urlAssets}/${assetPathStocks}/GOAU@3x.png`],
    ['GOLL', `${urlAssets}/${assetPathStocks}/GOLL@3x.png`],
    ['GOOG', `${urlAssets}/${assetPathStocks}/GOOG@3x.png`],
    ['GPAR', `${urlAssets}/${assetPathStocks}/GPAR@3x.png`],
    ['GPCP', `${urlAssets}/${assetPathStocks}/GPCP@3x.png`],
    ['GRAO', `${urlAssets}/${assetPathStocks}/GRAO@3x.png`],
    ['GRND', `${urlAssets}/${assetPathStocks}/GRND@3x.png`],
    ['GSHP', `${urlAssets}/${assetPathStocks}/GSHP@3x.png`],
    ['GUAR', `${urlAssets}/${assetPathStocks}/GUAR@3x.png`],
    ['HAGA', `${urlAssets}/${assetPathStocks}/HAGA@3x.png`],
    ['HAPV', `${urlAssets}/${assetPathStocks}/HAPV@3x.png`],
    ['HBOR', `${urlAssets}/${assetPathStocks}/HBOR@3x.png`],
    ['HBRE', `${urlAssets}/${assetPathStocks}/HBRE@3x.png`],
    ['HBSA', `${urlAssets}/${assetPathStocks}/HBSA@3x.png`],
    ['HBTS', `${urlAssets}/${assetPathStocks}/HBTS@3x.png`],
    ['HETA', `${urlAssets}/${assetPathStocks}/HETA@3x.png`],
    ['HGTX', `${urlAssets}/${assetPathStocks}/HGTX@3x.png`],
    ['HOOT', `${urlAssets}/${assetPathStocks}/HOOT@3x.png`],
    ['HYPE', `${urlAssets}/${assetPathStocks}/HYPE@3x.png`],
    ['IDNT', `${urlAssets}/${assetPathStocks}/IDNT@3x.png`],
    ['IDVL', `${urlAssets}/${assetPathStocks}/IDVL@3x.png`],
    ['IFCM', `${urlAssets}/${assetPathStocks}/IFCM@3x.png`],
    ['IGBR', `${urlAssets}/${assetPathStocks}/IGBR@3x.png`],
    ['IGSN', `${urlAssets}/${assetPathStocks}/IGSN@3x.png`],
    ['IGTA', `${urlAssets}/${assetPathStocks}/IGTA@3x.png`],
    ['INEP', `${urlAssets}/${assetPathStocks}/INEP@3x.png`],
    ['INNT', `${urlAssets}/${assetPathStocks}/INNT@3x.png`],
    ['INTB', `${urlAssets}/${assetPathStocks}/INTB@3x.png`],
    ['IRBR', `${urlAssets}/${assetPathStocks}/IRBR@3x.png`],
    ['ITSA', `${urlAssets}/${assetPathStocks}/ITSA@3x.png`],
    ['ITUB', `${urlAssets}/${assetPathStocks}/ITUB@3x.png`],
    ['JALL', `${urlAssets}/${assetPathStocks}/JALL@3x.png`],
    ['JBDU', `${urlAssets}/${assetPathStocks}/JBDU@3x.png`],
    ['JBSS', `${urlAssets}/${assetPathStocks}/JBSS@3x.png`],
    ['JFEN', `${urlAssets}/${assetPathStocks}/JFEN@3x.png`],
    ['JHSF', `${urlAssets}/${assetPathStocks}/JHSF@3x.png`],
    ['JOPA', `${urlAssets}/${assetPathStocks}/JOPA@3x.png`],
    ['JPSA', `${urlAssets}/${assetPathStocks}/JPSA@3x.png`],
    ['JSLG', `${urlAssets}/${assetPathStocks}/JSLG@3x.png`],
    ['KEPL', `${urlAssets}/${assetPathStocks}/KEPL@3x.png`],
    ['KLAS', `${urlAssets}/${assetPathStocks}/KLAS@3x.png`],
    ['KLBN', `${urlAssets}/${assetPathStocks}/KLBN@3x.png`],
    ['KRSA', `${urlAssets}/${assetPathStocks}/KRSA@3x.png`],
    ['LAME', `${urlAssets}/${assetPathStocks}/LAME@3x.png`],
    ['LAND', `${urlAssets}/${assetPathStocks}/LAND@3x.png`],
    ['LAVV', `${urlAssets}/${assetPathStocks}/LAVV@3x.png`],
    ['LCAM', `${urlAssets}/${assetPathStocks}/LCAM@3x.png`],
    ['LEVE', `${urlAssets}/${assetPathStocks}/LEVE@3x.png`],
    ['LIGT', `${urlAssets}/${assetPathStocks}/LIGT@3x.png`],
    ['LINX', `${urlAssets}/${assetPathStocks}/LINX@3x.png`],
    ['LIPR', `${urlAssets}/${assetPathStocks}/LIPR@3x.png`],
    ['LJQQ', `${urlAssets}/${assetPathStocks}/LJQQ@3x.png`],
    ['LLBI', `${urlAssets}/${assetPathStocks}/LLBI@3x.png`],
    ['LLIS', `${urlAssets}/${assetPathStocks}/LLIS@3x.png`],
    ['LMED', `${urlAssets}/${assetPathStocks}/LMED@3x.png`],
    ['LOGG', `${urlAssets}/${assetPathStocks}/LOGG@3x.png`],
    ['LOGN', `${urlAssets}/${assetPathStocks}/LOGN@3x.png`],
    ['LPSB', `${urlAssets}/${assetPathStocks}/LPSB@3x.png`],
    ['LREN', `${urlAssets}/${assetPathStocks}/LREN@3x.png`],
    ['LUPA', `${urlAssets}/${assetPathStocks}/LUPA@3x.png`],
    ['LUXM', `${urlAssets}/${assetPathStocks}/LUXM@3x.png`],
    ['LVTC', `${urlAssets}/${assetPathStocks}/LVTC@3x.png`],
    ['LWSA', `${urlAssets}/${assetPathStocks}/LWSA@3x.png`],
    ['MAPT', `${urlAssets}/${assetPathStocks}/MAPT@3x.png`],
    ['MATD', `${urlAssets}/${assetPathStocks}/MATD@3x.png`],
    ['MBLY', `${urlAssets}/${assetPathStocks}/MBLY@3x.png`],
    ['MDIA', `${urlAssets}/${assetPathStocks}/MDIA@3x.png`],
    ['MDNE', `${urlAssets}/${assetPathStocks}/MDNE@3x.png`],
    ['MEAL', `${urlAssets}/${assetPathStocks}/MEAL@3x.png`],
    ['MELK', `${urlAssets}/${assetPathStocks}/MELK@3x.png`],
    ['MERC', `${urlAssets}/${assetPathStocks}/MERC@3x.png`],
    ['MGEL', `${urlAssets}/${assetPathStocks}/MGEL@3x.png`],
    ['MGLU', `${urlAssets}/${assetPathStocks}/MGLU@3x.png`],
    ['MILS', `${urlAssets}/${assetPathStocks}/MILS@3x.png`],
    ['MLAS', `${urlAssets}/${assetPathStocks}/MLAS@3x.png`],
    ['MMAQ', `${urlAssets}/${assetPathStocks}/MMAQ@3x.png`],
    ['MMXM', `${urlAssets}/${assetPathStocks}/MMXM@3x.png`],
    ['MNDL', `${urlAssets}/${assetPathStocks}/MNDL@3x.png`],
    ['MNPR', `${urlAssets}/${assetPathStocks}/MNPR@3x.png`],
    ['MOAR', `${urlAssets}/${assetPathStocks}/MOAR@3x.png`],
    ['MODL', `${urlAssets}/${assetPathStocks}/MODL@3x.png`],
    ['MOSI', `${urlAssets}/${assetPathStocks}/MOSI@3x.png`],
    ['MOVI', `${urlAssets}/${assetPathStocks}/MOVI@3x.png`],
    ['MRFG', `${urlAssets}/${assetPathStocks}/MRFG@3x.png`],
    ['MRSA', `${urlAssets}/${assetPathStocks}/MRSA@3x.png`],
    ['MRVE', `${urlAssets}/${assetPathStocks}/MRVE@3x.png`],
    ['MSFT', `${urlAssets}/${assetPathStocks}/MSFT@3x.png`],
    ['MSPA', `${urlAssets}/${assetPathStocks}/MSPA@3x.png`],
    ['MSRO', `${urlAssets}/${assetPathStocks}/MSRO@3x.png`],
    ['MTIG', `${urlAssets}/${assetPathStocks}/MTIG@3x.png`],
    ['MTRE', `${urlAssets}/${assetPathStocks}/MTRE@3x.png`],
    ['MTSA', `${urlAssets}/${assetPathStocks}/MTSA@3x.png`],
    ['MULT', `${urlAssets}/${assetPathStocks}/MULT@3x.png`],
    ['MWET', `${urlAssets}/${assetPathStocks}/MWET@3x.png`],
    ['MYPK', `${urlAssets}/${assetPathStocks}/MYPK@3x.png`],
    ['NEMO', `${urlAssets}/${assetPathStocks}/NEMO@3x.png`],
    ['NEOE', `${urlAssets}/${assetPathStocks}/NEOE@3x.png`],
    ['NFLX', `${urlAssets}/${assetPathStocks}/NFLX@3x.png`],
    ['NGRD', `${urlAssets}/${assetPathStocks}/NGRD@3x.png`],
    ['NINJ', `${urlAssets}/${assetPathStocks}/NINJ@3x.png`],
    ['NORD', `${urlAssets}/${assetPathStocks}/NORD@3x.png`],
    ['NRTQ', `${urlAssets}/${assetPathStocks}/NRTQ@3x.png`],
    ['NTCO', `${urlAssets}/${assetPathStocks}/NTCO@3x.png`],
    ['NUTR', `${urlAssets}/${assetPathStocks}/NUTR@3x.png`],
    ['ODER', `${urlAssets}/${assetPathStocks}/ODER@3x.png`],
    ['ODPV', `${urlAssets}/${assetPathStocks}/ODPV@3x.png`],
    ['OFSA', `${urlAssets}/${assetPathStocks}/OFSA@3x.png`],
    ['OIBR', `${urlAssets}/${assetPathStocks}/OIBR@3x.png`],
    ['OMGE', `${urlAssets}/${assetPathStocks}/OMGE@3x.png`],
    ['ONCO', `${urlAssets}/${assetPathStocks}/ONCO@3x.png`],
    ['OPCT', `${urlAssets}/${assetPathStocks}/OPCT@3x.png`],
    ['ORVR', `${urlAssets}/${assetPathStocks}/ORVR@3x.png`],
    ['OSXB', `${urlAssets}/${assetPathStocks}/OSXB@3x.png`],
    ['PARD', `${urlAssets}/${assetPathStocks}/PARD@3x.png`],
    ['PASS', `${urlAssets}/${assetPathStocks}/PASS@3x.png`],
    ['PATI', `${urlAssets}/${assetPathStocks}/PATI@3x.png`],
    ['PCAR', `${urlAssets}/${assetPathStocks}/PCAR@3x.png`],
    ['PDGR', `${urlAssets}/${assetPathStocks}/PDGR@3x.png`],
    ['PDTC', `${urlAssets}/${assetPathStocks}/PDTC@3x.png`],
    ['PEAB', `${urlAssets}/${assetPathStocks}/PEAB@3x.png`],
    ['PETR', `${urlAssets}/${assetPathStocks}/PETR@3x.png`],
    ['PETZ', `${urlAssets}/${assetPathStocks}/PETZ@3x.png`],
    ['PFRM', `${urlAssets}/${assetPathStocks}/PFRM@3x.png`],
    ['PGMN', `${urlAssets}/${assetPathStocks}/PGMN@3x.png`],
    ['PINE', `${urlAssets}/${assetPathStocks}/PINE@3x.png`],
    ['PLAS', `${urlAssets}/${assetPathStocks}/PLAS@3x.png`],
    ['PLPL', `${urlAssets}/${assetPathStocks}/PLPL@3x.png`],
    ['PMAM', `${urlAssets}/${assetPathStocks}/PMAM@3x.png`],
    ['PNVL', `${urlAssets}/${assetPathStocks}/PNVL@3x.png`],
    ['POMO', `${urlAssets}/${assetPathStocks}/POMO@3x.png`],
    ['POSI', `${urlAssets}/${assetPathStocks}/POSI@3x.png`],
    ['POWE', `${urlAssets}/${assetPathStocks}/POWE@3x.png`],
    ['PPAR', `${urlAssets}/${assetPathStocks}/PPAR@3x.png`],
    ['PPLA', `${urlAssets}/${assetPathStocks}/PPLA@3x.png`],
    ['PRIO', `${urlAssets}/${assetPathStocks}/PRIO@3x.png`],
    ['PRNR', `${urlAssets}/${assetPathStocks}/PRNR@3x.png`],
    ['PSSA', `${urlAssets}/${assetPathStocks}/PSSA@3x.png`],
    ['PTBL', `${urlAssets}/${assetPathStocks}/PTBL@3x.png`],
    ['PTCA', `${urlAssets}/${assetPathStocks}/PTCA@3x.png`],
    ['PTNT', `${urlAssets}/${assetPathStocks}/PTNT@3x.png`],
    ['QUAL', `${urlAssets}/${assetPathStocks}/QUAL@3x.png`],
    ['QUSW', `${urlAssets}/${assetPathStocks}/QUSW@3x.png`],
    ['RADL', `${urlAssets}/${assetPathStocks}/RADL@3x.png`],
    ['RAIL', `${urlAssets}/${assetPathStocks}/RAIL@3x.png`],
    ['RAIZ', `${urlAssets}/${assetPathStocks}/RAIZ@3x.png`],
    ['RANI', `${urlAssets}/${assetPathStocks}/RANI@3x.png`],
    ['RAPT', `${urlAssets}/${assetPathStocks}/RAPT@3x.png`],
    ['RBNS', `${urlAssets}/${assetPathStocks}/RBNS@3x.png`],
    ['RCSL', `${urlAssets}/${assetPathStocks}/RCSL@3x.png`],
    ['RDNI', `${urlAssets}/${assetPathStocks}/RDNI@3x.png`],
    ['RDOR', `${urlAssets}/${assetPathStocks}/RDOR@3x.png`],
    ['RECV', `${urlAssets}/${assetPathStocks}/RECV@3x.png`],
    ['REDE', `${urlAssets}/${assetPathStocks}/REDE@3x.png`],
    ['RENT', `${urlAssets}/${assetPathStocks}/RENT@3x.png`],
    ['RNEW', `${urlAssets}/${assetPathStocks}/RNEW@3x.png`],
    ['ROMI', `${urlAssets}/${assetPathStocks}/ROMI@3x.png`],
    ['RPAD', `${urlAssets}/${assetPathStocks}/RPAD@3x.png`],
    ['RPMG', `${urlAssets}/${assetPathStocks}/RPMG@3x.png`],
    ['RRRP', `${urlAssets}/${assetPathStocks}/RRRP@3x.png`],
    ['RSID', `${urlAssets}/${assetPathStocks}/RSID@3x.png`],
    ['RSUL', `${urlAssets}/${assetPathStocks}/RSUL@3x.png`],
    ['SANB', `${urlAssets}/${assetPathStocks}/SANB@3x.png`],
    ['SAPR', `${urlAssets}/${assetPathStocks}/SAPR@3x.png`],
    ['SBFG', `${urlAssets}/${assetPathStocks}/SBFG@3x.png`],
    ['SBSP', `${urlAssets}/${assetPathStocks}/SBSP@3x.png`],
    ['SCAR', `${urlAssets}/${assetPathStocks}/SCAR@3x.png`],
    ['SEER', `${urlAssets}/${assetPathStocks}/SEER@3x.png`],
    ['SEQL', `${urlAssets}/${assetPathStocks}/SEQL@3x.png`],
    ['SGPS', `${urlAssets}/${assetPathStocks}/SGPS@3x.png`],
    ['SHOW', `${urlAssets}/${assetPathStocks}/SHOW@3x.png`],
    ['SHUL', `${urlAssets}/${assetPathStocks}/SHUL@3x.png`],
    ['SIMH', `${urlAssets}/${assetPathStocks}/SIMH@3x.png`],
    ['SLCE', `${urlAssets}/${assetPathStocks}/SLCE@3x.png`],
    ['SLED', `${urlAssets}/${assetPathStocks}/SLED@3x.png`],
    ['SMFT', `${urlAssets}/${assetPathStocks}/SMFT@3x.png`],
    ['SMLS', `${urlAssets}/${assetPathStocks}/SMLS@3x.png`],
    ['SMTO', `${urlAssets}/${assetPathStocks}/SMTO@3x.png`],
    ['SNSY', `${urlAssets}/${assetPathStocks}/SNSY@3x.png`],
    ['SOJA', `${urlAssets}/${assetPathStocks}/SOJA@3x.png`],
    ['SOMA', `${urlAssets}/${assetPathStocks}/SOMA@3x.png`],
    ['SOND', `${urlAssets}/${assetPathStocks}/SOND@3x.png`],
    ['SQIA', `${urlAssets}/${assetPathStocks}/SQIA@3x.png`],
    ['STBP', `${urlAssets}/${assetPathStocks}/STBP@3x.png`],
    ['STKF', `${urlAssets}/${assetPathStocks}/STKF@3x.png`],
    ['STTR', `${urlAssets}/${assetPathStocks}/STTR@3x.png`],
    ['SULA', `${urlAssets}/${assetPathStocks}/SULA@3x.png`],
    ['SUZB', `${urlAssets}/${assetPathStocks}/SUZB@3x.png`],
    ['TAEE', `${urlAssets}/${assetPathStocks}/TAEE@3x.png`],
    ['TASA', `${urlAssets}/${assetPathStocks}/TASA@3x.png`],
    ['TCNO', `${urlAssets}/${assetPathStocks}/TCNO@3x.png`],
    ['TCSA', `${urlAssets}/${assetPathStocks}/TCSA@3x.png`],
    ['TECN', `${urlAssets}/${assetPathStocks}/TECN@3x.png`],
    ['TEGA', `${urlAssets}/${assetPathStocks}/TEGA@3x.png`],
    ['TEKA', `${urlAssets}/${assetPathStocks}/TEKA@3x.png`],
    ['TELB', `${urlAssets}/${assetPathStocks}/TELB@3x.png`],
    ['TEND', `${urlAssets}/${assetPathStocks}/TEND@3x.png`],
    ['TESA', `${urlAssets}/${assetPathStocks}/TESA@3x.png`],
    ['TFCO', `${urlAssets}/${assetPathStocks}/TFCO@3x.png`],
    ['TGMA', `${urlAssets}/${assetPathStocks}/TGMA@3x.png`],
    ['TIET', `${urlAssets}/${assetPathStocks}/TIET@3x.png`],
    ['TIMS', `${urlAssets}/${assetPathStocks}/TIMS@3x.png`],
    ['TKNO', `${urlAssets}/${assetPathStocks}/TKNO@3x.png`],
    ['TOTS', `${urlAssets}/${assetPathStocks}/TOTS@3x.png`],
    ['TPIS', `${urlAssets}/${assetPathStocks}/TPIS@3x.png`],
    ['TRAD', `${urlAssets}/${assetPathStocks}/TRAD@3x.png`],
    ['TRIS', `${urlAssets}/${assetPathStocks}/TRIS@3x.png`],
    ['TRPL', `${urlAssets}/${assetPathStocks}/TRPL@3x.png`],
    ['TSLA', `${urlAssets}/${assetPathStocks}/TSLA@3x.png`],
    ['TTEN', `${urlAssets}/${assetPathStocks}/TTEN@3x.png`],
    ['TUPY', `${urlAssets}/${assetPathStocks}/TUPY@3x.png`],
    ['TWTR', `${urlAssets}/${assetPathStocks}/TWTR@3x.png`],
    ['TXRX', `${urlAssets}/${assetPathStocks}/TXRX@3x.png`],
    ['UCAS', `${urlAssets}/${assetPathStocks}/UCAS@3x.png`],
    ['UGPA', `${urlAssets}/${assetPathStocks}/UGPA@3x.png`],
    ['UNIP', `${urlAssets}/${assetPathStocks}/UNIP@3x.png`],
    ['USIM', `${urlAssets}/${assetPathStocks}/USIM@3x.png`],
    ['VALE', `${urlAssets}/${assetPathStocks}/VALE@3x.png`],
    ['VAMO', `${urlAssets}/${assetPathStocks}/VAMO@3x.png`],
    ['VIAA', `${urlAssets}/${assetPathStocks}/VIAA@3x.png`],
    ['VIVA', `${urlAssets}/${assetPathStocks}/VIVA@3x.png`],
    ['VIVR', `${urlAssets}/${assetPathStocks}/VIVR@3x.png`],
    ['VIVT', `${urlAssets}/${assetPathStocks}/VIVT@3x.png`],
    ['VLID', `${urlAssets}/${assetPathStocks}/VLID@3x.png`],
    ['VSPT', `${urlAssets}/${assetPathStocks}/VSPT@3x.png`],
    ['VULC', `${urlAssets}/${assetPathStocks}/VULC@3x.png`],
    ['VVEO', `${urlAssets}/${assetPathStocks}/VVEO@3x.png`],
    ['WEGE', `${urlAssets}/${assetPathStocks}/WEGE@3x.png`],
    ['WEST', `${urlAssets}/${assetPathStocks}/WEST@3x.png`],
    ['WHRL', `${urlAssets}/${assetPathStocks}/WHRL@3x.png`],
    ['WIZS', `${urlAssets}/${assetPathStocks}/WIZS@3x.png`],
    ['WLMM', `${urlAssets}/${assetPathStocks}/WLMM@3x.png`],
    ['YDUQ', `${urlAssets}/${assetPathStocks}/YDUQ@3x.png`]
]);

export { MapAssetCode };
//# sourceMappingURL=InitialavatarImageTypes.js.map
